var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    { staticClass: "br px-2 py-1", class: [_vm.colorText, _vm.bkgColor] },
    [_vm._t("label")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }